"use client";

import Icon from "@/components/icons/Icons";
import { addToast } from "@/components/ui/CustomToastManager";
import { AnimatePresence, easeIn, motion } from "framer-motion";
import React, { useState } from "react";

export default function ShareFundButton() {
  const [copied, setCopied] = useState(false);

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: document.title,
          text: "Check out this fund",
          url: window.location.href,
        });
      } catch (error) {
        console.error("Error sharing:", error);
      }
    } else {
      // fallback: copy to clipboard
      navigator.clipboard.writeText(window.location.href).then(() => {
        setCopied(true);
        addToast({
          title: "Link Copied!",
          description: "",
          status: "success",
        });
        setTimeout(() => setCopied(false), 3000);
      });
    }
  };

  return (
    <div className="relative block w-11 h-11">
      <button onClick={handleShare} aria-label="Share Fund Button" title="Click to share or copy the link">
        <Icon.sharedFundIcon className="text-[#6E6E73] transition duration-300 ease-linear hover:text-primaryBlack" />
      </button>

      {/* Tooltip for fallback copy */}
      <AnimatePresence mode="wait">
        {copied && (
          <motion.div initial={{ opacity: 0, x: 10, y: "-50%", scale: 0.8 }} animate={{ opacity: 1, x: 0, y: "-50%", scale: 1 }} exit={{ opacity: 0, x: -10, y: "-50%", scale: 0.8 }} transition={{ duration: 0.3, ease: easeIn }} className="absolute right-[110%] top-1/2 bg-black text-white text-xs px-2 py-1 rounded-sm z-1">
            <div className="absolute -right-1.5 top-1/2 -translate-y-1/2 w-0 h-0 border-t-8 border-b-8 border-l-8 border-transparent border-l-black z-2" />
            Link copied!
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
